<div class="modal-header">
  <h4 class="modal-title">Confirm Close</h4>
</div>
<div class="modal-body">
  No outcome recorded.<br />Are you sure you wish to Close?
</div>
<div class="modal-footer" *ngIf="viewModel$ | async as vm">
  <button
    type="button"
    class="btn btn-secondary mx-1"
    (click)="confirmClose()"
    [disabled]="vm.submitting"
  >
    Confirm
  </button>
  <button
    type="button"
    class="btn btn-secondary mx-1"
    (click)="activeModal.close('Cancel')"
  >
    Cancel
  </button>
</div>
